import PathwayNode from '@/components/nodes/PathwayNode';
import SystemNode from '@/components/nodes/SystemNode';
import ArrowNode from '@/components/nodes/ArrowNode';
import LimiterNode from '@/components/nodes/LimiterNode';
import BalancerNode from '@/components/nodes/BalancerNode';
import BlenderNode from '@/components/nodes/BlenderNode';
import PathwayEdge from '@/components/nodes/PathwayEdge';
import SuggestedEdge from '@/components/nodes/SuggestedEdge';

export const fitViewOptions = { maxZoom: 0.5, minZoom: 0.2, duration: 0 };
export const defaultViewport = { x: 0, y: 0, zoom: 0.5 };
export const proOptions = { hideAttribution: true };
export const nodeTypes = {
  pathwayNode: PathwayNode,
  systemNode: SystemNode,
  arrowNode: ArrowNode,
  limiterNode: LimiterNode,
  balancerNode: BalancerNode,
  blenderNode: BlenderNode,
};
export const edgeTypes = { pathwayEdge: PathwayEdge, suggestedEdge: SuggestedEdge };
